import React from 'react';
import PropTypes from 'prop-types';

export default class QualifiedPlayersListingFiltersTriggerButton extends React.PureComponent {
    getButtonText() {
        if (this.props.isFiltersVisible) {
            return 'Hide filters';
        }
        return 'Show filters';
    }

    render() {
        return (
            <button type="button" className="qualified-players-listing__filters-trigger"
                onClick={this.props.onClick}>
                <div className="button-content">
                    {this.getButtonText()}
                    <svg width="10" height="7"
                        className={`qualified-players-listing__filters-trigger-icon ${this.props.isFiltersVisible ? 'is-reversed' : ''}`}>
                        <use xlinkHref="#icon-arrow-down"></use>
                    </svg>
                </div>

            </button>
        );
    }
}

QualifiedPlayersListingFiltersTriggerButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    isFiltersVisible: PropTypes.bool.isRequired,
};
